module.exports = __webpack_public_path__ + "static/media/letterStatic.41409461.svg";